import React from 'react';

import { AnimatePresence } from 'framer-motion';

import IconCheck from '@pkg/assets/icons/check.svg?react';
import { type Collectible } from '@pkg/graphql/codegen/graphql';

import { useNFTsPageStore } from '@app/store/zustand';

import { ActionButton, CheckboxCircle, Count, SelectLabel, Wrapper } from './styles';

interface Props {
    nftEntries?: Collectible[];
}

export const SelectAllFloater = ({ nftEntries }: Props) => {
    const { isSelectAll, handleSelectAll, selectedItems } = useNFTsPageStore();

    return (
        <>
            <AnimatePresence initial={false}>
                {selectedItems.length > 0 && (
                    <Wrapper
                        initial={{ opacity: 0, y: 60, scale: 0.8 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: 60, scale: 0.8 }}
                    >
                        <SelectLabel onClick={() => handleSelectAll(nftEntries || [])}>
                            <CheckboxCircle $isChecked={isSelectAll}>
                                <IconCheck />
                            </CheckboxCircle>
                            {isSelectAll ? `Deselect all` : `Select all`}
                        </SelectLabel>

                        <ActionButton>
                            List selected
                            <Count>{selectedItems.length || 0}</Count>
                        </ActionButton>
                    </Wrapper>
                )}
            </AnimatePresence>
        </>
    );
};
